import { useQuery } from '@tanstack/react-query';
import axiosInstance from '@/dataProvider/axios';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { ORG_INVITATIONS_ENDPOINT } from '@/services/org-admin';
import type { OrgInvitationListResponse } from '@/services/org-admin';

export function useOrgInvitations() {
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useQuery({
    queryKey: ['org-invitations', orgId],
    queryFn: async () => {
      const { data } = await axiosInstance.get<OrgInvitationListResponse>(ORG_INVITATIONS_ENDPOINT(orgId!));
      return data.invitations;
    },
    enabled: !!orgId,
  });
}
